import { cn } from "@/lib/utils";
import { initials } from "@/lib/format";

const SIZES = { xs: "h-5 w-5 text-[9px]", sm: "h-6 w-6 text-[10px]", md: "h-8 w-8 text-xs", lg: "h-12 w-12 text-base" };

export function Avatar({ user, name, color, size = "md", className }) {
  const n = user?.name || name || "?";
  const c = user?.avatar_color || color || "#64748B";
  return (
    <span
      title={n}
      className={cn("inline-flex items-center justify-center rounded-full font-semibold text-white shrink-0 ring-2 ring-white dark:ring-slate-900", SIZES[size], className)}
      style={{ backgroundColor: c }}
    >
      {initials(n)}
    </span>
  );
}

export function AvatarStack({ users = [], max = 4, size = "sm" }) {
  const shown = users.slice(0, max);
  const extra = users.length - shown.length;
  return (
    <div className="flex items-center -space-x-2">
      {shown.map((u, i) => <Avatar key={u?.id || i} user={u} size={size} />)}
      {extra > 0 && (
        <span className={cn("inline-flex items-center justify-center rounded-full bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300 font-semibold ring-2 ring-white dark:ring-slate-900",
          size === "sm" ? "h-6 w-6 text-[10px]" : "h-8 w-8 text-xs")}>
          +{extra}
        </span>
      )}
    </div>
  );
}
